import { Box, Button, Container, TextField, Typography } from "@mui/material";
import { useState } from "react";
import { Link } from "react-router-dom";
import { useRegister } from "../hooks/useRegister";

const Register = () => {
  const { register } = useRegister();
  const [user, setUser] = useState({
    username: "",
    password: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUser({ ...user, [name]: value });
  };

  const handleClickRegister = () => {
    register(user);
  };

  return (
    <Container maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography variant="h5">ユーザ登録画面</Typography>

        <TextField
          margin="normal"
          required
          fullWidth
          name="username"
          label="名前"
          id="username"
          onChange={handleChange}
        />

        <TextField
          margin="normal"
          required
          fullWidth
          name="password"
          label="password"
          type="password"
          id="password"
          onChange={handleChange}
        />

        <Button
          fullWidth
          color="error"
          variant="contained"
          sx={{ mt: 3, mb: 2 }}
          onClick={handleClickRegister}
        >
          登録
        </Button>
        <Link to="/login">登録済みの方はこちら</Link>
      </Box>
    </Container>
  );
};

export default Register;
